import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PaginationInstance } from 'ngx-pagination';

@Component({
  selector: 'wm-pagination',
  template: `
    <div class='row rowbonus' id="pagination-block" *ngIf="!!config.totalItems">
      <pagination-template class="columns" #p="paginationApi"
                              [id]="config.id"
                              (pageChange)="changePage($event)">

        <div class="pagination" *ngIf="p.pages.length > 1">
          <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
            <a *ngIf="!p.isFirstPage()" (click)="p.previous()">
              <i class="icon-btn-left"></i>
            </a>
          </div>

          <div *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
            <a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
              <span>{{ page.label }}</span>
            </a>
            <div *ngIf="p.getCurrent() === page.value">
              <span>{{ page.label }}</span>
            </div>
          </div>

          <div class="pagination-next" [class.disabled]="p.isLastPage()">
            <a *ngIf="!p.isLastPage()" (click)="p.next()">
              <i class="icon-btn-right"></i>
            </a>
          </div>
        </div>
      </pagination-template>
    </div>
  `
})

export class WmPaginationComponent implements OnInit {
  loading: boolean;

  @Output() changePageCallback = new EventEmitter();
  @Input() config: PaginationInstance;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Object) => {
      let page = parseFloat(0 + params['page']);

      if (page > 0) {
        this.config.currentPage = page;
        this.changePage(page);
      } else {
        this.changePage(1);
      }
    });
  }

  getNumber(index) {
    return index + 1 + (this.config.currentPage - 1) * this.config.itemsPerPage;
  }

  changePage(page) {
    if (page !== this.config.currentPage) {
      this.router.navigate([], { queryParams: { page: page } });
      window.scrollTo(0, 0);
    } else {
      this.changePageCallback.emit(page);
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/pagination.component.ts